import { useQuery } from '@apollo/client';
import { gql } from '__generated__';
import { DepartmentType } from '__generated__/graphql';
import { FC } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import DetailsPanel from 'components/DetailsPanel';
import ErrorMessage from 'components/ErrorMessage';
import LoadingIndicator from 'components/LoadingIndicator';

import UpdateDepartment from './UpdateDepartment';

const DEPARTMENT_QUERY = gql(`
  query DepartmentInformation($departmentId: ID!) {
    department(id: $departmentId) {
      id
      name
      shortName
      cardNumberPrefix
      logo
      status
      updatedAt
      createdAt
    }
  }
`);

const DepartmentInformation: FC = () => {
  const { departmentId } = useParams<{ departmentId: string }>();

  const { loading, error, data, refetch } = useQuery(DEPARTMENT_QUERY, {
    variables: {
      departmentId: departmentId as string,
    },
  });

  const renderContent = () => {
    if (loading) return <LoadingIndicator />;

    if (error || !data) return <ErrorMessage error={error} refetch={refetch} />;

    const department = data.department;

    return (
      <>
        <UpdateDepartment department={department as DepartmentType} />
        <DetailsPanel
          data={[
            { label: 'Updated At', value: department.updatedAt, type: 'DATETIME' },
            { label: 'Created At', value: department.createdAt, type: 'DATETIME' },
          ]}
        />
      </>
    );
  };

  return (
    <>
      {renderContent()}
      <Outlet />
    </>
  );
};

export default DepartmentInformation;
